import { getSupportEntityTimelineRowId } from "modules/support/lib/supportEntityMarker"
import { ConversationSupportIssueUpdateItemResponseDataSchema } from "schema"
import { z } from "zod"
import { EntityRow } from "./EntityRow"
import { IssueReopenedBadge } from "./IssueReopenedBadge"
import { IssueUrgencyIdentifier } from "./IssueUrgencyIdentifier"

type Props = {
  item: z.infer<typeof ConversationSupportIssueUpdateItemResponseDataSchema>
  isFirst: boolean
  isLast: boolean
  onClick: () => void
}

export function IssueUpdateRow({ item, isFirst, isLast, onClick }: Props) {
  return (
    <EntityRow
      id={getSupportEntityTimelineRowId(item.kind, item.id)}
      bulletClassName="bg-support-secondary"
      text={item.issue.subject}
      textClassName="font-medium"
      isFirst={isFirst}
      isLast={isLast}
      onClick={onClick}
      badge={
        <span className="flex items-center gap-2">
          <IssueUrgencyIdentifier urgency={item.issue.urgency} />
          <IssueReopenedBadge issue={item.issue} />
        </span>
      }
    />
  )
}
